import { FaTrophy, FaUsers, FaClock, FaRupeeSign } from 'react-icons/fa';
import coachImage from '../../assets/image/image.png';

function HeroSection({ buyLink, onBuyClick }) {
  return (
    <section className="relative min-h-[90vh] flex items-center justify-center pt-28 pb-20 overflow-hidden">
      {/* Animated Background */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-br from-slate-800 via-slate-900 to-slate-800 animate-gradient-shift"></div>
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(251,191,36,0.15)_0%,transparent_50%),radial-gradient(circle_at_70%_80%,rgba(249,115,22,0.1)_0%,transparent_50%)]"></div>
        <div className="absolute -top-1/2 -left-1/2 w-[200%] h-[200%] bg-[radial-gradient(circle,rgba(251,191,36,0.05)_0%,transparent_50%)] animate-pulse-slow"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row items-center justify-center gap-10 lg:gap-20">
          {/* Hero Image */}
          <div className="flex-shrink-0">
            <div className="relative group">
              <div className="absolute -inset-1 bg-gradient-to-r from-amber-500/30 to-orange-500/30 rounded-3xl blur-lg opacity-50 group-hover:opacity-70 transition duration-500"></div>
              <div className="relative w-[280px] sm:w-[350px] lg:w-[450px] rounded-3xl overflow-hidden border-4 border-amber-500/30 shadow-2xl shadow-black/50 group-hover:border-amber-500/50 transition-all duration-300 group-hover:scale-[1.02]">
                <img 
                  src={coachImage} 
                  alt="Rushneek Singh - Payment Recovery Expert"
                  className="w-full h-auto"
                />
              </div>
            </div>
          </div>

          {/* Hero Text */}
          <div className="flex-1 max-w-xl text-center lg:text-left">
            {/* Badge */}
            <div className="inline-flex items-center gap-2 bg-white/40 backdrop-blur-xl border-2 border-white/60 text-amber-400 px-7 py-3 rounded-full text-base font-extrabold mb-8 shadow-lg">
              <FaTrophy className="text-lg" />
              <span className="drop-shadow-md">India's #1 B2B Payment Recovery Coach</span>
            </div>

            {/* Title */}
            <h1 className="text-5xl sm:text-6xl lg:text-7xl xl:text-8xl font-black leading-[1.05] mb-7 tracking-tight">
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-white via-amber-400 to-white drop-shadow-lg">
              Credit Control system and Payment Recovery Formula
              </span>
            </h1>

            {/* Subtitle */}
            <p className="text-xl sm:text-2xl lg:text-[26px] text-sky-100 font-semibold mb-12 leading-relaxed max-w-[650px] drop-shadow-[0_2px_4px_rgba(0,0,0,0.3)]">
              Transform your business with a proven 8-week system to recover stuck payments, build positive cash flow, and achieve zero bad debt.
            </p>

            {/* CTA Button */}
            <button 
              onClick={onBuyClick}
              className="inline-block bg-gradient-to-r from-amber-400 via-amber-500 to-orange-500 text-slate-900 px-12 sm:px-16 py-4 sm:py-5 rounded-xl text-lg sm:text-2xl font-extrabold shadow-[0_10px_30px_-5px_rgba(251,191,36,0.5)] hover:shadow-[0_20px_40px_-8px_rgba(251,191,36,0.6)] hover:-translate-y-1 hover:scale-105 transition-all duration-300 tracking-wide"
            >
              Book Your Consultation Call →
            </button>
        
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
